import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function WRWhyChoose() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-2389">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-2390">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-2391">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-2392">
            WHY CHOOSE BE CLINICAL FOR YOUR WRINKLE RELAXERS
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-10" data-id="element-2393"></div>

          <div className="space-y-6 text-[#B0B0B0] text-[17px] leading-[1.8] font-body mb-10" data-id="element-2394">
            <p data-id="element-2395">
              At Be CLINICAL, we expertly provide wrinkle relaxers that not only
              provide instant, natural-looking results but also serve as a
              proactive measure against future signs of aging. When you come in
              for your consultation your provider will determine the best
              wrinkle relaxer for your goals. Led by our team of skilled
              professionals, we understand the importance of achieving lasting
              yet subtle outcomes. With a commitment to safety, efficacy, and
              patient satisfaction, we tailor each treatment to your unique
              needs, delivering results that are both impressive and
              understated.
            </p>
            <p data-id="element-2396">
              Choose Be CLINICAL for wrinkle relaxers that offer the perfect
              balance of instant gratification and long-term benefits, helping
              you look and feel your best every day. Book your complimentary
              consultation today!
            </p>
          </div>

          <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-2397">
            BOOK CONSULT
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}